import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/ArbolCategoria`

export function buscarTodos() {
  return http.get(`${API_ENDPOINT}/BuscarTodos`)
}

export function buscarSubcategoria(idCategoria) {
  return http.get(`${API_ENDPOINT}/BuscarSubcategoria/${idCategoria}`)
}
